<template>
    <div v-if="application" class="uk-form">
        <!-- Home Owner Fields -->
        <div v-if="application.home_owner == 1">

            <fieldset data-uk-margin>
                <legend>The Property Has (check all that apply)</legend>
                <div class="uk-grid uk-margin-bottom">
                    <div class="uk-width-medium-1-3 uk-margin-bottom">
                        <validated-section :errors="errors" field="owner_liens">
                            <label>
                                <input type="checkbox" v-model="owner.liens.first"/>
                                A First Lien
                            </label>
                        </validated-section>
                    </div>
                    <div class="uk-width-medium-1-3 uk-margin-bottom">
                        <label>
                            <input type="checkbox" v-model="owner.liens.second"/>
                            A Second Lien
                        </label>
                    </div>
                    <div class="uk-width-medium-1-3 uk-margin-bottom">
                        <label>
                            <input type="checkbox" v-model="owner.liens.additional"/>
                            Additional Subordinate Lien(s)
                        </label>
                    </div>
                </div>
                <hr class="uk-grid-divider">

                <legend>My property taxes and insurance</legend>
                <div class="uk-grid uk-margin-bottom">
                    <div class="uk-width-medium-1-4 uk-margin-bottom">
                        <validated-section :errors="errors" field="escrowed">
                            <label><input type="radio" v-model="owner.escrowed" :value="0" class=""> Both my taxes and insurance
                                are escrowed.</label>
                        </validated-section>

                    </div>
                    <div class="uk-width-medium-1-4 uk-margin-bottom">
                        <label><input type="radio" v-model="owner.escrowed" :value="1"
                                      onClick="UIkit.modal.alert('Attention! You will need to provide proof that your taxes and insurance are not delinquent.');">
                            Neither my taxes or my insurance are escrowed.</label>
                    </div>
                    <div class="uk-width-medium-1-4 uk-margin-bottom">
                        <label><input type="radio" v-model="owner.escrowed" :value="2"
                                      onClick="UIkit.modal.alert('Attention! You will need to provide proof that your insurance is not delinquent.')">
                            My taxes are escrowed, but not my insurance.</label>
                    </div>
                    <div class="uk-width-medium-1-4 uk-margin-bottom">
                        <label><input type="radio" v-model="owner.escrowed" :value="3"
                                      onClick="UIkit.modal.alert('Attention! You will need to provide proof that your taxes are not delinquent.')">
                            My insurance is escrowed, but not my taxes.</label>
                    </div>

                </div>
                <hr class="uk-grid-divider">

                <legend>I have homeowners association (HOA) fees</legend>
                <div class="uk-grid uk-margin-bottom">
                    <div class="uk-width-medium-1-3 uk-margin-bottom">
                        <validated-section :errors="errors" field="hoa">
                            <label><input type="radio" v-model="owner.hoa" :value="0"> I do not have HOA fees.</label>
                        </validated-section>
                    </div>
                    <div class="uk-width-medium-1-3 uk-margin-bottom">
                        <label><input type="radio" v-model="owner.hoa" :value="1"> Yes, and they are current (all HOA dues have
                            been paid to date).</label>
                    </div>
                    <div class="uk-width-medium-1-3 uk-margin-bottom">
                        <label><input type="radio" v-model="owner.hoa" :value="2"
                                      onClick="UIkit.modal.alert('Attention! Your HOA fees must be current to be eligible for the program.');">
                            Yes, and they are NOT current (I am behind on my HOA dues).</label>
                    </div>


                </div>
                <hr class="uk-grid-divider">

                <legend class="">First Mortgage Information</legend>

                <div class="uk-container ">
                    <div class="uk-grid">
                        <div class="uk-width-medium-5-10 ">
                            <validated-section :errors="errors" field="mortgageServiceProvider">
                                <input type="text" placeholder="First Mortgage Servicer Name"
                                       v-model="application.mortgage_servicer"
                                       class="uk-width-1-1 uk-margin-bottom uk-form-large">
                            </validated-section>

                        </div>
                        <div class="uk-width-medium-5-10 ">
                            <validated-section :errors="errors" field="mortgageAccountNumber">
                                <input type="text" placeholder="Account Number"
                                       v-model="owner.mortgageAccountNumber"
                                       class="uk-width-1-1 uk-margin-bottom uk-form-large">
                            </validated-section>

                        </div>
                    </div>
                    <div class="uk-grid">

                        <div class="uk-width-medium-1-2 uk-margin-bottom">
                            <label><input type="radio" v-model="owner.mortgageCurrent" @change="onCurrentMortgageChanged" :value="true">
                                I am <strong>CURRENT</strong> on
                                this mortgage.
                            </label>
                        </div>
                        <div class="uk-width-medium-1-2 uk-margin-bottom">
                            <label><input type="radio" v-model="owner.mortgageCurrent" :value="false"> I am <strong>BEHIND</strong> on this mortgage.</label>

                        </div>

                        <div class="uk-width-medium-5-10 ">
                            <validated-section :errors="errors" field="unpaidPrincipalAmount">
                                <vue-numeric currency="$" v-model="owner.unpaidPrincipalAmount" v-show="owner.mortgageCurrent" type="text"
                                             placeholder="Unpaid Principal Balance"
                                             class="uk-width-1-1 uk-margin-bottom uk-form-large" />
                            </validated-section>
                        </div>
                        <div class="uk-width-medium-5-10 ">
                            <validated-section :errors="errors" field="delinquentAmount">
                                <vue-numeric currency="$" v-model="owner.delinquentAmount" v-show="!owner.mortgageCurrent" type="text"
                                             placeholder="Amount Delinquent"
                                             class="uk-width-1-1 uk-margin-bottom uk-form-large" />
                            </validated-section>
                        </div>
                    </div>


                    <hr class="uk-grid-divider uk-margin-bottom uk-margin-top app-fades" style="border:none;">
                </div>

            </fieldset>
        </div>
        <!-- Water Utility Fields -->
        <div class="uk-form"  v-if="application.program.water_program">

            <fieldset class="uk-margin-large-top">
                <legend>
                    Do You Need Assistance for Your Water Utility?
                    <toggle-button :value="needWaterAssistance" v-model="needWaterAssistance" :sync="true" :labels="{checked: 'Yes', unchecked: 'No' }"></toggle-button>
                </legend>

            </fieldset>
            <fieldset v-if="needWaterAssistance" id="water-utility">

                <validated-section :errors="errors" field="utility_paid_to">
                    I pay my water utility to my:
                    <ul>
                        <li><input type="radio" v-model="application.utility_paid_to" :value="0"> Landlord</li>
                        <li><input type="radio" v-model="application.utility_paid_to" :value="1"> Water Utility Company</li>
                    </ul>
                </validated-section>


                <div class="uk-width-1-1">
                <fieldset>
                <label class="">My Disconnect Status:</label><br/>
                    <validated-section :errors="errors" field="applicant_disconnect_status_id">
                        <select v-model="application.applicant_disconnect_status_id" class="uk-input uk-select">
                            <option :value="0"></option>
                            <option :value="1">My Utility Has Been Disconnected</option>
                            <option :value="2">My Utility Has Issued a Disconnect Notice</option>
                            <option :value="3">I am Struggling to Pay My Utility</option>
                        </select>
                    </validated-section>

                   </fieldset>
                </div>
                <p>Place a check next to each month in which you need aid.</p>
                <validated-section :errors="errors" field="utility_months"></validated-section>
                <div class="uk-overflow-container uk-hidden-small uk-grid-width-medium-1-1">
                    <table class="uk-table uk-table-divider uk-table-striped">
                        <thead>
                        <tr>
                            <th>Month</th>
                            <th>Due</th>
                            <th>Paid</th>
                            <th>Fees Due</th>
                            <th class="uk-text-right">Total Requested</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="month in water.months">
                            <td>
                                <input type="checkbox" :value="month.format('YYYYMM')" v-model="water.checkedMonths"/>
                                {{ month.format('MMM YYYY') }}
                            </td>
                            <td>
                                <div v-if="water.checkedMonths.includes(month.format('YYYYMM'))">
                                    <input type="number" @change="$forceUpdate()"
                                           v-model="water.monthInputs[month.format('YYYY-MM')]['due']">
                                </div>
                                <span v-else>-</span>
                            </td>
                            <td>
                                <div v-if="water.checkedMonths.includes(month.format('YYYYMM'))">
                                    <input type="number" @change="$forceUpdate()"
                                           v-model="water.monthInputs[month.format('YYYY-MM')]['paid']">
                                </div>
                                <span v-else>-</span>
                            </td>
                            <td>
                                <div v-if="water.checkedMonths.includes(month.format('YYYYMM'))">
                                    <input type="number" @change="$forceUpdate()"
                                           v-model="water.monthInputs[month.format('YYYY-MM')]['fees']">
                                </div>
                                <span v-else>-</span>
                            </td>
                            <td>
                                <div v-if="water.checkedMonths.includes(month.format('YYYYMM'))" class="uk-text-right">
                                    {{ getRequestedWaterAssistanceForMonth(month.format('YYYY-MM')) | formatMoney}}
                                </div>
                                <span v-else>-</span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="uk-grid uk-width-small-1-1 uk-hidden-medium uk-hidden-large uk-form uk-form-horizontal uk-form-stacked">
                    <div class="uk-width-1-1 uk-grid" v-for="month in water.months">
                        <div class="uk-width-1-1">
                            <h4>
                                <input type="checkbox" :value="month.format('YYYYMM')" v-model="water.checkedMonths"/>
                                {{ month.format('MMM YYYY') }}
                            </h4>

                        </div>
                        <div class="uk-width-1-1 uk-margin-top uk-margin-large-bottom" v-if="water.checkedMonths.includes(month.format('YYYYMM'))">
                            <div class="uk-form-row">
                                <label class="uk-form-label" for="">{{ month.format('MMMM') }} Due</label>
                                <div class="uk-form-controls">
                                    <vue-numeric currency="$" v-model="water.monthInputs[month.format('YYYY-MM')]['due']"></vue-numeric>
                                </div>
                            </div>
                            <div class="uk-form-row">
                                <label class="uk-form-label" for="">{{ month.format('MMMM') }} Rent Paid</label>
                                <div class="uk-form-controls">
                                    <vue-numeric currency="$" v-model="water.monthInputs[month.format('YYYY-MM')]['paid']"></vue-numeric>
                                </div>
                            </div>
                            <div class="uk-form-row">
                                <label class="uk-form-label" for="">{{ month.format('MMMM') }} Fees Due</label>
                                <div class="uk-form-controls">
                                    <vue-numeric currency="$" v-model="water.monthInputs[month.format('YYYY-MM')]['fees']"></vue-numeric>
                                </div>
                            </div>
                            <div class="uk-form-row">
                                <label class="uk-form-label" for="">{{ month.format('MMMM') }} Amount Requested</label>
                                <div class="uk-form-controls">
                                    <strong>{{ getRequestedWaterAssistanceForMonth(month.format('YYYY-MM')) | formatMoney}}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>

        <!-- Renter Fields -->
        <div v-if="application.home_owner != 1 && application.program.rent_program" class="uk-form" >
            <fieldset class="uk-margin-large-top uk-grid uk-width-9-10 uk-align-center">
                <legend>
                    Do You Need Rent Assistance?
                    <toggle-button :value="needRentAssistance" v-model="needRentAssistance" @change="onRentChanged" :sync="true" :labels="{checked: 'Yes', unchecked: 'No' }"></toggle-button>
                </legend>

            </fieldset>
            <fieldset class="uk-grid uk-width-1-1" v-if="needRentAssistance">
                <div class="uk-width-1-1">
                    <fieldset>
                        <label class="">My Eviction Status:</label><br/>
                        <validated-section :errors="errors" field="applicant_eviction_status_id">
                            <select v-model="application.applicant_eviction_status_id" class="uk-input uk-select">
                                <option :value="0"></option>
                                <option :value="1">I Have Received a 3 Day Notice</option>
                                <option :value="2">I Have Received a Court Date Notice</option>
                                <option :value="3">I Am Not Delinquent, But I am Struggling to Pay Rent</option>
                                <option :value="4">I Am Delinquent But I Have Not Received an Eviction Notice</option>
                            </select>
                        </validated-section>
                    </fieldset>
                </div>
            </fieldset>


            <fieldset class="uk-width-1-1" v-if="needRentAssistance">
                <h2 class="uk-margin-large-top">Renter Information</h2>
            </fieldset>

            <fieldset class="uk-width-1-1" v-if="!eviction && needRentAssistance">
                <p>Place a check next to each month in which you need aid.</p>
                <validated-section :errors="errors" field="rent_months"></validated-section>
                <div class="uk-overflow-container uk-hidden-small uk-grid-width-medium-1-1">
                    <table class="uk-table uk-table-divider uk-table-striped">
                        <thead>
                        <tr>
                            <th>Month</th>
                            <th>Rent Due</th>
                            <th>Rent Paid</th>
                            <th>Fees / Deposit Due</th>
                            <th class="uk-text-right">Total Requested</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="month in rent.months">
                            <td>
                                <input type="checkbox" :value="month.format('YYYYMM')" v-model="rent.checkedMonths"/>
                                {{ month.format('MMM YYYY') }}
                            </td>
                            <td>
                                <div v-if="rent.checkedMonths.includes(month.format('YYYYMM'))">
                                    <input type="number" @change="$forceUpdate()"
                                           v-model="rent.monthInputs[month.format('YYYY-MM')]['due']">
                                </div>
                                <span v-else>-</span>
                            </td>
                            <td>
                                <div v-if="rent.checkedMonths.includes(month.format('YYYYMM'))">
                                    <input type="number" @change="$forceUpdate()"
                                           v-model="rent.monthInputs[month.format('YYYY-MM')]['paid']">
                                </div>
                                <span v-else>-</span>
                            </td>
                            <td>
                                <div v-if="rent.checkedMonths.includes(month.format('YYYYMM'))">
                                    <input type="number" @change="$forceUpdate()"
                                           v-model="rent.monthInputs[month.format('YYYY-MM')]['fees']">
                                </div>
                                <span v-else>-</span>
                            </td>
                            <td>
                                <div v-if="rent.checkedMonths.includes(month.format('YYYYMM'))" class="uk-text-right">
                                    {{ getRequestedRentAssistanceForMonth(month.format('YYYY-MM')) | formatMoney}}
                                </div>
                                <span v-else>-</span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="uk-grid uk-width-small-1-1 uk-hidden-medium uk-hidden-large uk-form uk-form-horizontal uk-form-stacked">
                    <validated-section :errors="errors" field="rent_months"></validated-section>
                    <div class="uk-width-1-1 uk-grid" v-for="month in rent.months">
                        <div class="uk-width-1-1">
                            <h4>
                                <input type="checkbox" :value="month.format('YYYYMM')" v-model="rent.checkedMonths"/>
                                {{ month.format('MMM YYYY') }}
                            </h4>
                        </div>
                        <div class="uk-width-1-1 uk-margin-top uk-margin-large-bottom" v-if="rent.checkedMonths.includes(month.format('YYYYMM'))">
                            <div class="uk-form-row">
                                <label class="uk-form-label" for="">{{ month.format('MMMM') }} Rent Due</label>
                                <div class="uk-form-controls">
                                    <vue-numeric currency="$" v-model="rent.monthInputs[month.format('YYYY-MM')]['due']"></vue-numeric>
                                </div>
                            </div>
                            <div class="uk-form-row">
                                <label class="uk-form-label" for="">{{ month.format('MMMM') }} Paid</label>
                                <div class="uk-form-controls">
                                    <vue-numeric currency="$" v-model="rent.monthInputs[month.format('YYYY-MM')]['paid']"></vue-numeric>
                                </div>
                            </div>
                            <div class="uk-form-row">
                                <label class="uk-form-label" for="">{{ month.format('MMMM') }} Fees / Deposit Due</label>
                                <div class="uk-form-controls">
                                    <vue-numeric currency="$" v-model="rent.monthInputs[month.format('YYYY-MM')]['fees']"></vue-numeric>
                                </div>
                            </div>
                            <div class="uk-form-row">
                                <label class="uk-form-label" for="">{{ month.format('MMMM') }} Amount Requested</label>
                                <div class="uk-form-controls">
                                    <strong>{{ getRequestedRentAssistanceForMonth(month.format('YYYY-MM')) | formatMoney}}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>



        <div class="uk-margin-large-top">
            <h2 class="uk-text-right">Total Assistance Requested: {{ getTotalReqeusted() | formatMoney }}</h2>
        </div>

    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import moment from 'moment';
    import ValidatedSection from "../../../../../components/Common/ValidatedSection";
    import PropertyContactForm from "../../../../../components/AppWizard/Step2/PropertyContactForm";

    export default {
        name: "Step2",
        components: {PropertyContactForm, ValidatedSection},
        data() {
            return {
                errors: {},

                eviction: false,
                evictionDeposit: 0,
                evictionRent: 0,
                evictionNewName: '',
                evictionContactPhone: '',
                evictionContactEmail: '',


                rent: {
                    checkedMonths: [],
                    monthInputs: {},
                    months: [
                        // moment('2020-04-15'),
                        // moment('2020-05-15'),
                        // moment('2020-06-15'),
                        // moment('2020-07-15'),
                        // moment('2020-08-15'),
                        // moment('2020-09-15'),
                        // moment('2020-10-15'),
                        // moment('2020-11-15'),
                        // moment('2020-12-15'),
                    ],
                },
                needWaterAssistance: false,
                needRentAssistance: false,
                water: {
                    checkedMonths: [],
                    monthInputs: {},
                    months: [
                        // moment('2020-04-15'),
                        // moment('2020-05-15'),
                        // moment('2020-06-15'),
                        // moment('2020-07-15'),
                        // moment('2020-08-15'),
                        // moment('2020-09-15'),
                        // moment('2020-10-15'),
                        // moment('2020-11-15'),
                        // moment('2020-12-15'),
                    ],
                },

                owner: {
                    liens: {
                        first: false,
                        second: false,
                        additional: false,
                    },
                    escrowed: null,
                    hoa: null,
                    mortgageServiceProvider: '',
                    mortgageAccountNumber: '',
                    mortgageCurrent: true,
                    unpaidPrincipalAmount: 0,
                    delinquentAmount: 0,
                }
            }
        },
        computed: {
            ...mapState('Application', {
                application: state => state.application,
                renterOwner: state => state.renterOwner,
                renterManager: state => state.renterManager,
                organization: state => state.organization,
            })
        },
        watch: {
            application(newValue) {
                this.initData();
            },
            'owner.liens.second': (newValue) => {
                if(newValue == true) {
                    UIkit.modal.alert('Attention! Please be aware that our current programs will only provide assistance for your primary loan.');
                }
            },
            'owner.liens.additional': (newValue) => {
                if(newValue == true) {
                    UIkit.modal.alert('Attention! Please be aware that our current programs will only provide assistance for your primary loan.');
                }
            },
            'rent.checkedMonths': function(newValue) {
                // Clear any unchecked months.
                _.each(this.rent.monthInputs, (input, dateString) => {
                    let dateKey = dateString.replace('-', '');
                    if(!this.rent.checkedMonths.includes(dateKey)) {
                        input.due = 0;
                        input.paid = 0;
                        input.fees = 0;
                    }
                });
            },
            'water.checkedMonths': function(newValue) {
                // Clear any unchecked months.
                _.each(this.water.monthInputs, (input, dateString) => {
                    let dateKey = dateString.replace('-', '');
                    if(!this.water.checkedMonths.includes(dateKey)) {
                        input.due = 0;
                        input.paid = 0;
                        input.fees = 0;
                    }
                });
            },
        },
        mounted() {
            if(this.application) {
                this.initData();
            }
        },
        methods: {
            // Init Helpers
            getUtilityMetaForDate(dateString) {
                if(!this.application || !this.application.requested_utilities_meta) return null;
                for(var i in this.application.requested_utilities_meta) {
                    let record = this.application.requested_utilities_meta[i];
                    if(record.date == dateString) {
                        return record;
                    }
                }
                return null;
            },
            getRentMetaForDate(dateString) {
                if(!this.application || !this.application.requested_rent_meta) return null;
                for(var i in this.application.requested_rent_meta) {
                    let record = this.application.requested_rent_meta[i];
                    if(record.date == dateString) {
                        return record;
                    }
                }
                return null;
            },
            initData() {
                this.owner.liens.first = this.application.has_first_lien == 1;
                this.owner.liens.second = this.application.has_second_lien == 1;
                this.owner.liens.additional = this.application.has_additional_lien == 1;
                this.owner.mortgageCurrent = this.application.mortgage_current == 1;
                this.owner.unpaidPrincipalAmount = this.application.mortgage_unpaid_principal_amount === null ? 0 : parseFloat(this.application.mortgage_unpaid_principal_amount);
                this.owner.delinquentAmount = this.application.mortgage_delinquent_amount === null ? 0 : parseFloat(this.application.mortgage_delinquent_amount);
                this.owner.escrowed = this.application.escrow_value;
                this.owner.hoa = this.application.hoa_value;
                this.owner.mortgageServiceProvider = this.application.mortgage_servicer ? this.application.mortgage_servicer : '';
                this.owner.mortgageAccountNumber = this.application.mortgage_account_number ? this.application.mortgage_account_number : '';
                this.mortgageAmount = parseFloat(this.application.requested_mortgage_amount);

                this.eviction = this.application.is_eviction == 1;
                this.evictionDeposit = this.application.eviction_deposit ? this.application.eviction_deposit : 0;
                this.evictionRent = this.application.eviction_rent ? this.application.eviction_rent : 0;
                this.evictionNewName = this.application.eviction_name ? this.application.eviction_name : '';
                this.evictionContactPhone = this.application.eviction_phone ? this.application.eviction_phone : '';
                this.evictionContactEmail = this.application.eviction_email ? this.application.eviction_email : '';

                this.needWaterAssistance = this.application.utility_assistance == 1;
                this.needRentAssistance = this.application.requested_rent_amount > 0 || this.application.applicant_eviction_status_id !== null;

                // Use application.program.assistance_start and assistance_end to determind which months to show
                let months = [];
                let startDate = this.application.program.assistance_start === null ? moment('2020-04-15') : moment(this.application.program.assistance_start);
                let endDate = this.application.program.assistance_end === null ? moment('2020-12-15') : moment(this.application.program.assistance_end);
                let numberOfMonths = endDate.diff(startDate, 'months');
                _.times(numberOfMonths, () => {
                    let newDate = startDate.clone();
                    let now = moment();
                    if(newDate.month() > now.month() && newDate.year() >= now.year()) {
                        return;
                    }
                    months.push(newDate);
                    startDate.add(1, 'month');
                })
                this.water.months = months;
                this.rent.months = months;
                this.water.checkedMonths = [];
                this.rent.checkedMonths = [];


                _.each(this.water.months, month => {
                    let monthString = month.format('YYYY-MM');
                    let record = this.getUtilityMetaForDate(monthString)
                    if(record) {
                        console.log('water record', monthString, record);
                        this.water.checkedMonths.push(month.format('YYYYMM'));
                    }
                    this.$set(this.water.monthInputs, monthString, {
                        due: record ? parseFloat(record.due) : 0,
                        paid: record ? parseFloat(record.paid) : 0,
                        fees: record ? parseFloat(record.fees) : 0,
                    });
                });
                _.each(this.rent.months, month => {
                    let monthString = month.format('YYYY-MM');
                    let record = this.getRentMetaForDate(monthString)
                    if(record) {
                        this.rent.checkedMonths.push(month.format('YYYYMM'));
                    }
                    this.$set(this.rent.monthInputs, monthString, {
                        due: record ? parseFloat(record.due) : 0,
                        paid: record ? parseFloat(record.paid) : 0,
                        fees: record ? parseFloat(record.fees) : 0,
                    });
                });


            },
            onRentChanged($event) {
                console.log($event);
                if($event.value === false) {
                    this.application.applicant_eviction_status_id = null;
                    _.each(this.rent.monthInputs, (input) => {
                        input.due = 0;
                        input.paid = 0;
                        input.fees = 0;
                    })
                }
            },
            isSequential(array) {
               let length = array.length;
               if(length === 1) return true;
               let first = array.shift();
               let last = array.pop();
               let diff = last.diff(first, 'months');
               // console.log("Difference between " + first + ' and ' + last + " is " + diff);
               return diff === length-1;
            },
            validateConsecutive(values, maxConsecutive) {
                let months = [];
                _.each(values, (amounts, key) => {
                    if(amounts.due > 0 || amounts.fees > 0 || amounts.paid > 0) {
                        months.push(moment(key+'-15'));
                    }
                })

                // console.log(months);

                if(months.length > maxConsecutive) {
                    return false;
                }

                // make sure months are consecutive
                let sequential = this.isSequential(months);

                if(!sequential) return false;

                return true;
            },
            async validateStep() {
                this.errors = {};

                if(this.application.home_owner) {

                    if(this.owner.liens.first === false && this.owner.liens.first === false && this.owner.liens.first === false) {
                        this.errors['owner_liens'] = { errors: ['You must select at least one lien option.']};
                    }

                    if(this.owner.escrowed === null) {
                        this.errors['escrowed'] = { errors: ['You must make a taxes and insurance selection.']}
                    }

                    if(this.owner.hoa === null) {
                        this.errors['hoa'] = { errors: ['You must make a HOA selection.']}
                    }

                    if(this.owner.mortgageCurrent === true && (this.owner.unpaidPrincipalAmount === 0 || this.owner.unpaidPrincipalAmount === null)) {
                        this.errors['unpaidPrincipalAmount'] = { errors: ['You must enter an amount.']}
                    }

                    if(this.owner.mortgageCurrent === false && (this.owner.delinquentAmount === 0 || this.owner.delinquentAmount === null)) {
                        this.errors['delinquentAmount'] = { errors: ['You must enter an amount.']}
                    }

                    if(this.owner.mortgageAccountNumber === null || this.owner.mortgageAccountNumber === '') {
                        this.errors['mortgageAccountNumber'] = { errors: ['Mortgage Account Number is required.']}
                    }

                    if(this.application.mortgage_servicer === null || this.application.mortgage_servicer === '') {
                        this.errors['mortgageServiceProvider'] = { errors: ['Mortgage Servicer Name is required.']}
                    }
                }

                if(this.application.renter) {
                    // Needs property owner and manager

                    if(!this.renterManager.person_id && !this.application.landlord_first_name && (this.needRentAssistance || this.application.utility_paid_to == 0)) {
                        this.errors.renterManager = { errors: ['You must have a property manager selected.']}
                    }

                }

                if(this.needWaterAssistance) {
                    // Require utility_paid to
                    if(this.application.utility_paid_to === null) {
                        this.errors['utility_paid_to'] = { errors: ['This field is required.'] };
                    }

                    // Require applicant_disconnect_status_id
                    if(this.application.applicant_disconnect_status_id === null) {
                        this.errors['applicant_disconnect_status_id'] = { errors: ['This field is required.'] };
                    }

                    if(this.application.program.consecutive_month_constraint !== null && this.application.program.consecutive_month_constraint !== 0) {
                        if(!this.validateConsecutive(this.water.monthInputs, this.application.program.consecutive_month_constraint)) {
                            this.errors['utility_months'] = { errors: ['You can only select up to ' + this.application.program.consecutive_month_constraint + ' consecutive months.']};
                        }
                    }
                }

                if(this.needRentAssistance) {
                    if(this.application.applicant_eviction_status_id === null) {
                        this.errors['applicant_eviction_status_id'] = { errors: ['This field is required.'] };
                    }

                    if(this.application.program.consecutive_month_constraint !== null && this.application.program.consecutive_month_constraint !== 0) {
                        if(!this.validateConsecutive(this.rent.monthInputs, this.application.program.consecutive_month_constraint)) {
                            this.errors['rent_months'] = { errors: ['You can only select up to ' + this.application.program.consecutive_month_constraint + ' consecutive months.']};
                        }
                    }
                }


                if(_.size(this.errors) > 0) return false;


                // Server Validation
                try {
                    let r = await this.save();
                    // Success
                    return true;
                }catch(err) {
                    this.errors = err.response.data.errors;
                    return false;
                }
            },
            save() {
                let utilityAmount = 0;
                for(var i in this.water.monthInputs) {
                    utilityAmount += this.getRequestedWaterAssistanceForMonth(i);
                }
                let data = {
                    utility_assistance: this.needWaterAssistance,
                    requested_utilities_amount: utilityAmount,
                    requested_utilities_meta: JSON.stringify(this.getFilteredUtilityInputs()),
                };
                if(this.application.home_owner) {
                    let mortgageAmount = (this.owner.mortgageCurrent) ? this.owner.unpaidPrincipalAmount : this.owner.delinquentAmount;

                    data['has_first_lien'] = this.owner.liens.first;
                    data['has_second_lien'] = this.owner.liens.second;
                    data['has_additional_lien'] = this.owner.liens.additional;
                    data['mortgage_current'] = this.owner.mortgageCurrent;
                    data['mortgage_unpaid_principal_amount'] = this.owner.unpaidPrincipalAmount;
                    data['mortgage_delinquent_amount'] = this.owner.delinquentAmount;
                    data['escrow_value'] = this.owner.escrowed;
                    data['hoa_value'] = this.owner.hoa;
                    data['mortgage_servicer'] = this.application.mortgage_servicer;
                    data['mortgage_account_number'] = this.owner.mortgageAccountNumber;
                    data['requested_mortgage_amount'] = mortgageAmount;
                    data['service_name'] = this.application.service_name;
                }
                if(this.application.renter) {
                    let rentAmount = 0;
                    _.each(this.rent.monthInputs, (input, i) => {
                        rentAmount += this.getRequestedRentAssistanceForMonth(i);
                    })

                    data['requested_rent_amount'] = rentAmount;
                    data['requested_rent_meta'] = JSON.stringify(this.getFilteredRentInputs());

                    data['manager_company_name'] = this.application.manager_company_name;
                    data['owner_company_name'] = this.application.owner_company_name;
                }
                data['utility_paid_to'] = this.application.utility_paid_to;
                data['applicant_disconnect_status_id'] = this.application.applicant_disconnect_status_id;
                data['applicant_eviction_status_id'] = this.application.applicant_eviction_status_id;

                return axios.put(`/api/hope/applications/${this.application.id}/step-2`, data)
            },

            getTotalReqeusted() {
              let total = 0;
              if(this.application.renter) {
                  for (let i in this.rent.monthInputs) {
                      total += this.getRequestedRentAssistanceForMonth(i);
                  }
              }

              if(this.application.home_owner) {
                  if(this.owner.mortgageCurrent) {
                      total += parseFloat(this.owner.unpaidPrincipalAmount)
                  }else {
                      total += parseFloat(this.owner.delinquentAmount);
                  }
              }

              _.each(this.water.monthInputs, (data, month) => {
                total += this.getRequestedWaterAssistanceForMonth(month);
              })
                total += parseFloat(this.evictionDeposit);
                total += parseFloat(this.evictionRent);

              return total;
            },
            getRequestedRentAssistanceForMonth(month) {
                let due = this.rent.monthInputs[month]['due'];
                let paid = this.rent.monthInputs[month]['paid'];
                let fees = this.rent.monthInputs[month]['fees'];

                return parseFloat(due) - parseFloat(paid) + parseFloat(fees);
            },

            getRequestedWaterAssistanceForMonth(month) {
                let due = this.water.monthInputs[month]['due'];
                let paid = this.water.monthInputs[month]['paid'];
                let fees = this.water.monthInputs[month]['fees'];

                return parseFloat(due) - parseFloat(paid) + parseFloat(fees);
            },
            validate() {
                return true;
            },

            getFilteredRentInputs()
            {
                let inputs = [];
                _.each(this.rent.monthInputs, (input, month) => {
                    if(input.due !== 0 || input.fees !== 0 || input.paid !== 0) {
                        inputs.push({
                            date: month,
                            due: input.due,
                            fees: input.fees,
                            paid: input.paid,
                        });
                    }
                });
                return inputs;
            },
            getFilteredUtilityInputs()
            {
                let inputs = [];
                _.each(this.water.monthInputs, (input, month) => {
                    if(input.due !== 0 || input.fees !== 0 || input.paid !== 0) {
                        inputs.push({
                            date: month,
                            due: input.due,
                            fees: input.fees,
                            paid: input.paid,
                        });
                    }
                });
                return inputs;
            },

            onCurrentMortgageChanged($event) {
                if($event.checked) {this.owner.delinquentAmount = 0;}
            },
        }
    }
</script>

<style scoped lang="scss">

</style>
